<template>
  <div :class="['teeth-chart',locale=='HE' ? 'rtl':'']">
    <label v-if="!displayMode" class="mb-xl" for="chooseMethod">
      <form-field
        :class="['single', 'my-m', chartHoveredNoMethod ? 'border-red-5' : '']"
        :locale= "locale"
        field-type="select"
        :select-options="[
          { value: 1, label: 'ADA' },
          { value: 2, label: 'FDI' }
        ]"
        v-bind:select-placeholder="localize('Choose method')"
        v-model.number="teethDataMethod"
        multi
        wide
        rounded
      ></form-field>
    </label>
    <div
      class="teeth-chart--form"
      @mouseenter="teethDataMethod < 1 ? (chartHoveredNoMethod = true) : null"
      @mouseleave="chartHoveredNoMethod = false"
      :class="[teethDataMethod < 1 ? 'disabled' : '',locale]"
    >
      <div
        v-for="(group, i) in tableData"
        class="tooth-group py-s"
        :class="{ disabled: disabledToothGroup.indexOf(i) > -1 }"
        :key="i"
      >
        <tooth
          v-for="item in group.toothGroup"
          :key="item.id"
          v-bind="item"
          :method="teethDataMethod"
          :tooth-options="toothOptions"
          @tooth-updated="updateTeeth($event, item)"
          :display-mode="displayMode"
        ></tooth>
      </div>
      <div class="teeth-chart--legend my-l">
        <div v-for="t in toothOptions" :key="t.value" class="tooth-legend mx-s">
          <span class="mx-xs" v-text="t.label"></span>
          <span v-text="t.desc"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tooth from "./Tooth.vue";
import { mapState, mapActions } from "vuex";

export default {
  props: {
    value: {
      type: Array
    },
    fieldType: {
      type: String,
      default: "text"
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    // tableStructure: {
    //   type: [Array, Object],
    //   required: true
    // },
    method: {
      type: [String, Number]
    },
    displayMode: {
      type: Boolean,
      default: false
    },

    /*
      Initial data from saved draft
      and for display mode
    */
    selectedData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  watch: {
    teethDataMethod() {
      this.$emit("method-updated", this.teethDataMethod);
    },
    selectedData() {
      // console.log("selected Data changed! <<", this.selectedData);
      this.initTableData();
    }
  },
  data() {
    return {
      updateTrigger: -1,
      chartHoveredNoMethod: false,
      teethData: [],
      tableData: [],
      teethDataMethod: -1,
      toothOptions: [
        { value: 0, label: " ", desc: "None", inMlab: true },
        { value: 1, label: "X", desc: "Tooth Extraction Site", inMlab: true },
        { value: 2, label: "O", desc: "Implant Site", inMlab: false },
        { value: 3, label: "B", desc: "Both", inMlab: false }
      ],
      toothTableItems: [
        { ToothID: 1, ToothNumberADA: 1, ToothImage: [1], ToothNumberFDI: 18 },
        { ToothID: 2, ToothNumberADA: 2, ToothImage: [1], ToothNumberFDI: 17 },
        { ToothID: 3, ToothNumberADA: 3, ToothImage: [1], ToothNumberFDI: 16 },
        { ToothID: 4, ToothNumberADA: 4, ToothImage: [2], ToothNumberFDI: 15 },
        { ToothID: 5, ToothNumberADA: 5, ToothImage: [2], ToothNumberFDI: 14 },
        { ToothID: 6, ToothNumberADA: 6, ToothImage: [3], ToothNumberFDI: 13 },
        { ToothID: 7, ToothNumberADA: 7, ToothImage: [4], ToothNumberFDI: 12 },
        { ToothID: 8, ToothNumberADA: 8, ToothImage: [4], ToothNumberFDI: 11 },
        { ToothID: 9, ToothNumberADA: 9, ToothImage: [4], ToothNumberFDI: 21 },
        {
          ToothID: 10,
          ToothNumberADA: 10,
          ToothImage: [4],
          ToothNumberFDI: 22
        },
        {
          ToothID: 11,
          ToothNumberADA: 11,
          ToothImage: [3],
          ToothNumberFDI: 23
        },
        {
          ToothID: 12,
          ToothNumberADA: 12,
          ToothImage: [4],
          ToothNumberFDI: 24
        },
        {
          ToothID: 13,
          ToothNumberADA: 13,
          ToothImage: [4],
          ToothNumberFDI: 25
        },
        {
          ToothID: 14,
          ToothNumberADA: 14,
          ToothImage: [1],
          ToothNumberFDI: 26
        },
        {
          ToothID: 15,
          ToothNumberADA: 15,
          ToothImage: [1],
          ToothNumberFDI: 27
        },
        {
          ToothID: 16,
          ToothNumberADA: 16,
          ToothImage: [1],
          ToothNumberFDI: 28
        },

        {
          ToothID: 32,
          ToothNumberADA: 32,
          ToothImage: [5],
          ToothNumberFDI: 48
        },
        {
          ToothID: 31,
          ToothNumberADA: 31,
          ToothImage: [5],
          ToothNumberFDI: 47
        },
        {
          ToothID: 30,
          ToothNumberADA: 30,
          ToothImage: [5],
          ToothNumberFDI: 46
        },
        {
          ToothID: 29,
          ToothNumberADA: 29,
          ToothImage: [2, "y"],
          ToothNumberFDI: 45
        },
        {
          ToothID: 28,
          ToothNumberADA: 28,
          ToothImage: [2, "y"],
          ToothNumberFDI: 44
        },
        {
          ToothID: 27,
          ToothNumberADA: 27,
          ToothImage: [3, "y"],
          ToothNumberFDI: 43
        },
        {
          ToothID: 26,
          ToothNumberADA: 26,
          ToothImage: [4, "y"],
          ToothNumberFDI: 42
        },
        {
          ToothID: 25,
          ToothNumberADA: 25,
          ToothImage: [4, "y"],
          ToothNumberFDI: 41
        },
        {
          ToothID: 24,
          ToothNumberADA: 24,
          ToothImage: [4, "y"],
          ToothNumberFDI: 31
        },
        {
          ToothID: 23,
          ToothNumberADA: 23,
          ToothImage: [4, "y"],
          ToothNumberFDI: 32
        },
        {
          ToothID: 22,
          ToothNumberADA: 22,
          ToothImage: [3, "y"],
          ToothNumberFDI: 33
        },
        {
          ToothID: 21,
          ToothNumberADA: 21,
          ToothImage: [2, "y"],
          ToothNumberFDI: 34
        },
        {
          ToothID: 20,
          ToothNumberADA: 20,
          ToothImage: [2, "y"],
          ToothNumberFDI: 35
        },
        {
          ToothID: 19,
          ToothNumberADA: 19,
          ToothImage: [5, "x"],
          ToothNumberFDI: 36
        },

        {
          ToothID: 18,
          ToothNumberADA: 18,
          ToothImage: [5, "x"],
          ToothNumberFDI: 37
        },
        {
          ToothID: 17,
          ToothNumberADA: 17,
          ToothImage: [5, "x"],
          ToothNumberFDI: 38
        }
      ]
      // method: 1
    };
  },
  mounted() {
    this.teethDataMethod = this.method;
    this.initTableData();

    //Translate Options
    this.toothOptions[0].desc = this.localize('none');
    this.toothOptions[1].desc = this.localize('tooth_ex_site');
    this.toothOptions[2].desc = this.localize('implant_site');
    this.toothOptions[3].desc = this.localize('both');

    this.$nextTick(function() {
      this.$emit("validate-chart", "teethChart", this.hasImplantSite);
    });
  },
  components: {
    Tooth
  },
  // props: ["label", "value"],
  methods: {
    initTableData() {
      let _data = [];
      // console.log("this.tableStructure>>>", this.tableStructure);
      let table = this.toothTableItems.map(item => {
        let id = item.ToothID;
        let ADA = item.ToothNumberADA;
        let img = item.ToothImage;
        let FDI = item.ToothNumberFDI;
        let obj = { id, ADA, img, FDI };

        if (this.selectedData && this.selectedData.length) {
          let selectedItem = _.find(this.selectedData, { id });
          // console.log("selectedItem > ", selectedItem);
          if (selectedItem) {
            return Object.assign({ opt: selectedItem.opt }, obj);
          }
        }
        return obj;
      });
      // console.log("table >>>> ", table);

      for (var i = 0; i < 4; i++) {
        let v = i * 8;
        _data.push({
          toothGroup: table.slice(v, v + 8)
        });
      }
      // this.$set(this, "tableData", _data);
      this.tableData = _data;
      return _data;
    },
    updateVal() {
      this.$emit("input", this.$refs.field.value);
    },
    updateTeeth(e, tooth) {
      // console.log("update tooth id > ", e, " :: ", tooth.id);
      let td = this.teethData;
      let i = td.findIndex(item => item.id === tooth.id);
      let obj = Object.assign(tooth, { opt: e });
      let updatedTooth = {};
      // delete obj.img;
      if (td.length && i > -1) {
        if (e === 0) {
          // REMOVE
          td.splice(i, 1);
          // REMOVE TOOTH FROM PARENT
          updatedTooth = { id: obj.id, opt: null };
          // this.$emit("tooth-update", );
        } else {
          td[i] = obj;
          updatedTooth = { id: obj.id, opt: obj.opt };

          // this.$emit("tooth-update", {
          //   id: obj.id,
          //   opt: obj.opt
          // });
        }
      } else {
        updatedTooth = obj;
        td.push(obj);
      }
      this.updateTrigger = new Date().getTime();
      this.$emit("tooth-update", updatedTooth);
      // console.log("update teethdata > ", td);
      this.$emit("validate-chart", "teethChart", this.hasImplantSite);

      // this.$emit("input", td);
    }
  },
  computed: {
    ...mapState(["locale"]),
    hasImplantSite() {
      this.updateTrigger;
      let teeth = this.teethData;
      if (teeth.length) {
        return !!_.filter(teeth, t => t.opt !== 1).length;
      }
      return false;
    },
    disabledToothGroup() {
      // Will disable either top or bottom jaw, according to teeth selected...
      let teeth = this.teethData;
      let id;
      if (teeth.length) {
        id = teeth[0].id;
        if (id < 17) {
          return [2, 3];
        } else {
          return [0, 1];
        }
      }
      return [];
    }
    // tableData() {
    // }
  }
};
</script>



<style scoped>
   .teeth-chart--form.disabled.EN::after{ 
    content:'Choose method';
  }
  .teeth-chart--form.disabled.DE::after{ 
    content:'Methode wählen';
  }
  .teeth-chart--form.disabled.ES::after{ 
    content:'Seleccione el método';
  }
  .teeth-chart--form.disabled.FR::after{ 
    content:'Choisir une méthode';
  }
  .teeth-chart--form.disabled.RU::after{ 
    content:'Выбрать метод';
  }
  .teeth-chart--form.disabled.PL::after{ 
    content:'Wybierz metodę';
  }
 </style>

<style lang="stylus" scoped>
.teeth-chart
  &.rtl
    .tooth-group
      &:nth-child(1)
        border-right 0px
        border-left 1px solid mix(blue_brand, blue_1)
      &:nth-child(3)
        border-right 0px
        border-left 1px solid mix(blue_brand, blue_1)

  &--form  
    _flex(row, wrap, center, center)
    width 100%
    &:after
      content 'Please Choose method'
      color #fff
      text-align center
      font-size 20px
      line-height 45vh
      position absolute
      top 0
      left 0
      right 0
      bottom 0
      background #fff
      opacity 0
      z-index -1
      transition opacity 0.8s ease-out-cubic, color 0.5s ease-out
    position relative
    &.disabled
      &:after
        z-index 999999999
        opacity 0.7
        color blue_7


  .tooth-group
    _flex(row, wrap, flex-end, flex-end, true)
    flex 0 0 50%
    min-height 140px
    &.disabled
      pointer-events none
      opacity 0.8
      position relative
      &:after
        content ''
        position absolute
        top 0
        left 0
        width 100%
        height 100%
        background rgba(168,221,255,0.3)
        //background rgba(gray_4, 0.6)
    .tooth
      display flex
      flex-direction column
      & > *
        flex none        
    &:nth-child(1)
      border-bottom 1px solid mix(blue_brand, blue_1)
      border-right 1px solid mix(blue_brand, blue_1)
    &:nth-child(2)
      border-bottom 1px solid mix(blue_brand, blue_1)
    &:nth-child(3)
      _flex(row, wrap, flex-start, flex-end, true)
      border-right 1px solid mix(blue_brand, blue_1)

      .tooth
        flex-direction column-reverse
    &:nth-child(4)
      _flex(row, wrap, flex-start, flex-end, true)
      .tooth
        flex-direction column-reverse
  &--legend
    width 100%
    _flex(row, wrap, center, flex-start)
    .tooth-legend
      _flex(row, wrap, center, flex-start)
      span:first-child
        display inline-block
        border 1px solid gray_4
        background lighten(blue_1, 17)
        width 16px
        height 16px
        line-height 13px
        text-align center
        font-size 14px
        pointer-events none
</style>
